import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const MediaFilterBar = ({ 
  searchQuery,
  onSearchChange,
  filterType,
  onFilterTypeChange,
  sortBy,
  onSortChange,
  viewMode,
  onViewModeChange 
}) => {
  const typeOptions = [
    { value: 'all', label: 'All Media' },
    { value: 'photo', label: 'Photos Only' },
    { value: 'video', label: 'Videos Only' }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'downloads-desc', label: 'Most Downloaded' },
    { value: 'views-desc', label: 'Most Viewed' }
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-3 md:p-4">
      <div className="flex flex-col lg:flex-row gap-3 md:gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search media files..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
          <Select
            options={typeOptions}
            value={filterType}
            onChange={onFilterTypeChange}
            placeholder="Filter by type"
            className="w-full sm:w-40"
          />

          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Sort by"
            className="w-full sm:w-48"
          />

          <div className="flex gap-2 bg-muted rounded-lg p-1">
            <button
              onClick={() => onViewModeChange('grid')}
              className={`p-2 rounded transition-all ${
                viewMode === 'grid' ?'bg-card shadow-warm-sm' :'hover:bg-card/50'
              }`}
              aria-label="Grid view"
            >
              <Icon name="Grid3x3" size={18} />
            </button>
            <button
              onClick={() => onViewModeChange('list')}
              className={`p-2 rounded transition-all ${
                viewMode === 'list' ?'bg-card shadow-warm-sm' :'hover:bg-card/50'
              }`}
              aria-label="List view"
            >
              <Icon name="List" size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaFilterBar;